import React, { SyntheticEvent } from 'react';
import { ReactEditor } from 'slate-react';
import { Editor } from 'slate';
import { Button } from 'components/text-editor/components/controls/components/markup-menu/style';
import useCustomEditor from 'components/text-editor/hooks/use-custom-editor';

export enum MarkupMenuDecoration {
  HIGHLIGHT = 'highlight',
  UNDERLINE = 'underline',
  STRIKETHROUGH = 'strikethrough',
}

export interface MarkupMenuDecorationButtonProps {
  decoration: MarkupMenuDecoration;
  children: any;
}

const defaultProps = {};

function MarkupMenuDecorationButton(props: MarkupMenuDecorationButtonProps) {
  const { children, decoration } = props;
  const editor = useCustomEditor();
  const shouldRemoveDecoration = hasDecoration(editor, decoration);

  const toggleDecoration = (event: SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();

    const shouldRemoveDecoration = hasDecoration(editor, decoration);

    const selectedNode = editor.getSelectedNode();

    if (selectedNode) {
      const at = ReactEditor.findPath(editor, selectedNode);

      const shouldRemoveDecoration = selectedNode[decoration];

      const matchSelected = (node) => Boolean(node.isSelected);

      return editor.updateAnnotation(
        {
          [decoration]: !shouldRemoveDecoration,
          annotationId: selectedNode.annotationId,
        },
        { at, match: matchSelected, mode: 'lowest' },
      );
    }

    shouldRemoveDecoration
      ? Editor.removeMark(editor, decoration)
      : Editor.addMark(editor, decoration, true);
  };

  // The event listener must be onMouseDown rather than onClick
  // because onClick is flaky; onClick occasionally does not apply
  // styles when clicked
  return (
    <Button onMouseDown={toggleDecoration} selected={shouldRemoveDecoration}>
      {children}
    </Button>
  );
}

MarkupMenuDecorationButton.defaultProps = defaultProps;

/**
 * Checks if the selected piece of text has an underline, highlight or strikethrough,
 * depending on the second argument.
 * @param editor
 * @param decoration
 */
function hasDecoration(
  editor: ReactEditor,
  decoration: MarkupMenuDecoration,
): boolean {
  const [match] = Editor.nodes(editor, {
    match: (node) => Object.keys(node).includes(decoration),
    mode: 'all',
  });

  return Boolean(match);
}

export default MarkupMenuDecorationButton;
